document.addEventListener('DOMContentLoaded', () => {

  /* ========================================================
     RW ERA
     ======================================================== */

  const rwEra =
    document.querySelector('#rw-era');

  if (!rwEra) return;


  /* ========================================================
     ELEMENTS
     ======================================================== */

  const content =
    rwEra.querySelector('#rw-era-content');

  const collectionView =
    rwEra.querySelector('#rw-era-collection-view');

  const productView =
    rwEra.querySelector('#rw-era-product-view');

  const sidebar =
    rwEra.querySelector('.rw-era__sidebar-nav');

  const mobileSelector =
    rwEra.querySelector('.rw-era__mobile-selector');

  const mobileSelectorTitle =
    rwEra.querySelector(
      '.rw-era__mobile-selector-title'
    );

  const mobileSelectorCount =
    rwEra.querySelector(
      '.rw-era__mobile-selector-count'
    );


  if (
    !content ||
    !collectionView ||
    !productView ||
    !sidebar
  ) {

    console.error(
      'RW Era: Required elements are missing.'
    );

    return;

  }


  /* ========================================================
     SHOPIFY ROOT URL
     ======================================================== */

  const shopifyRoot =
    window.Shopify?.routes?.root || '/';


  /* ========================================================
     STORAGE
     ======================================================== */

  const STORAGE_KEY =
    'rw-era-product-filters';


  function getDefaultFilters() {

    return {
      sortBy: '',
      priceMin: '',
      priceMax: ''
    };

  }


  function getSavedFilters() {

    try {

      const saved =
        sessionStorage.getItem(
          STORAGE_KEY
        );

      if (!saved) {

        return getDefaultFilters();

      }


      const parsed =
        JSON.parse(saved);


      return {

        sortBy:
          parsed.sortBy || '',

        priceMin:
          parsed.priceMin || '',

        priceMax:
          parsed.priceMax || ''

      };


    } catch (error) {

      return getDefaultFilters();

    }

  }


  function saveFilters(filters = {}) {

    try {

      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({

          sortBy:
            filters.sortBy || '',

          priceMin:
            filters.priceMin || '',

          priceMax:
            filters.priceMax || ''

        })
      );


    } catch (error) {

      console.warn(
        'RW Era: Unable to save filters.',
        error
      );

    }

  }


  function clearSavedFilters() {

    try {

      sessionStorage.removeItem(
        STORAGE_KEY
      );


    } catch (error) {

      console.warn(
        'RW Era: Unable to clear saved filters.',
        error
      );

    }

  }


  /* ========================================================
     MOBILE
     ======================================================== */

  function isMobile() {

    return window.matchMedia(
      '(max-width: 989px)'
    ).matches;

  }


  function openMobileSelector() {

    if (
      !mobileSelector ||
      !isMobile()
    ) {

      return;

    }


    sidebar.classList.add(
      'is-mobile-open'
    );


    mobileSelector.setAttribute(
      'aria-expanded',
      'true'
    );

  }


  function closeMobileSelector() {

    if (!mobileSelector) return;


    sidebar.classList.remove(
      'is-mobile-open'
    );


    mobileSelector.setAttribute(
      'aria-expanded',
      'false'
    );

  }


  function updateMobileSelector(item) {

    if (
      !mobileSelectorTitle ||
      !mobileSelectorCount ||
      !item
    ) {

      return;

    }


    const title =
      item.querySelector(
        '.rw-era__sidebar-title'
      )?.textContent.trim()
      || 'All Era Collections';


    const count =
      item.querySelector(
        '.rw-era__sidebar-count'
      )?.textContent.trim()
      || '';


    mobileSelectorTitle.textContent =
      title;


    mobileSelectorCount.textContent =
      count;

  }


  if (mobileSelector) {

    mobileSelector.addEventListener(
      'click',
      () => {

        if (!isMobile()) return;


        const isOpen =
          mobileSelector.getAttribute(
            'aria-expanded'
          ) === 'true';


        if (isOpen) {

          closeMobileSelector();

        } else {

          openMobileSelector();

        }

      }
    );

  }


  /* ========================================================
     MOBILE PRICE DROPDOWN
     ======================================================== */

  function setupPriceDropdown() {

    const priceToggle =
      content.querySelector(
        '.rw-era__price-toggle'
      );


    const priceContainer =
      content.querySelector(
        '.price-filer-container'
      );


    if (
      !priceToggle ||
      !priceContainer
    ) {

      return;

    }


    priceToggle.setAttribute(
      'aria-expanded',
      priceContainer.classList.contains(
        'is-open'
      )
        ? 'true'
        : 'false'
    );


    if (
      priceToggle.dataset.rwEraInitialized ===
      'true'
    ) {

      return;

    }


    priceToggle.dataset.rwEraInitialized =
      'true';


    priceToggle.addEventListener(
      'click',
      (event) => {

        event.preventDefault();
        event.stopPropagation();


        if (!isMobile()) return;


        const isOpen =
          priceContainer.classList.contains(
            'is-open'
          );


        priceContainer.classList.toggle(
          'is-open',
          !isOpen
        );


        priceToggle.setAttribute(
          'aria-expanded',
          String(!isOpen)
        );

      }
    );

  }


  setupPriceDropdown();


  /* ========================================================
     CLOSE PRICE DROPDOWN
     ======================================================== */

  function closePriceDropdown() {

    const priceToggle =
      content.querySelector(
        '.rw-era__price-toggle'
      );


    const priceContainer =
      content.querySelector(
        '.price-filer-container'
      );


    if (!priceContainer) return;


    priceContainer.classList.remove(
      'is-open'
    );


    if (priceToggle) {

      priceToggle.setAttribute(
        'aria-expanded',
        'false'
      );

    }

  }


  /* ========================================================
     SORT COLLECTION CARDS -// return countB - countA; commented
     ======================================================== */

  const collectionGrid =
    rwEra.querySelector(
      '.rw-era__collections'
    );


  if (collectionGrid) {

    const cards =
      Array.from(
        collectionGrid.querySelectorAll(
          '.rw-era__collection-card'
        )
      );


    cards.sort((a, b) => {

      const countA =
        Number(
          a.dataset.productsCount || 0
        );


      const countB =
        Number(
          b.dataset.productsCount || 0
        );


      // return countB - countA;

    });


    cards.forEach((card) => {

      collectionGrid.appendChild(
        card
      );

    });

  }


  /* ========================================================
     SORT SIDEBAR - // return countB - countA; commented
     ======================================================== */

  const allCollectionsButton =
    sidebar.querySelector(
      '[data-view="collections"]'
    );


  const collectionButtons =
    Array.from(
      sidebar.querySelectorAll(
        '[data-view="products"]'
      )
    );


  collectionButtons.sort((a, b) => {

    const countA =
      Number(
        (
          a.querySelector(
            '.rw-era__sidebar-count'
          )?.textContent || ''
        ).replace(
          /[^0-9]/g,
          ''
        )
      );


    const countB =
      Number(
        (
          b.querySelector(
            '.rw-era__sidebar-count'
          )?.textContent || ''
        ).replace(
          /[^0-9]/g,
          ''
        )
      );


    return countB - countA;

  });


  if (allCollectionsButton) {

    sidebar.appendChild(
      allCollectionsButton
    );

  }


  collectionButtons.forEach((button) => {

    sidebar.appendChild(
      button
    );

  });


  /* ========================================================
     INITIAL MOBILE SELECTOR
     ======================================================== */

  if (allCollectionsButton) {

    updateMobileSelector(
      allCollectionsButton
    );

  }


  /* ========================================================
     ACTIVE SIDEBAR
     ======================================================== */

  function setActiveSidebarItem(item) {

    sidebar
      .querySelectorAll(
        '.rw-era__sidebar-item'
      )
      .forEach((button) => {

        button.classList.remove(
          'is-active'
        );

      });


    if (item) {

      item.classList.add(
        'is-active'
      );


      updateMobileSelector(
        item
      );

    }

  }


  /* ========================================================
     SHOW ALL COLLECTIONS
     ======================================================== */

  function showAllCollections() {

    collectionView.hidden =
      false;


    productView.hidden =
      true;


    productView.innerHTML =
      '';


    content.classList.remove(
      'is-loading'
    );


    closePriceDropdown();

  }


  /* ========================================================
     ERROR
     ======================================================== */

  function showError(message) {

    productView.innerHTML = `
      <div class="rw-era__error">
        ${message}
      </div>
    `;


    collectionView.hidden =
      true;


    productView.hidden =
      false;

  }


  /* ========================================================
     GET CURRENT INPUT VALUES
     
     IMPORTANT:
     This function reads ONLY what is currently typed.
     
     It does NOT fall back to old dataset values.
     ======================================================== */

  function getProductFilters(wrapper = null) {

    const source =
      wrapper ||
      content.querySelector(
        '#rw-era-products'
      );


    if (!source) {

      return getDefaultFilters();

    }


    const sortSelect =
      source.querySelector(
        '[data-rw-era-sort]'
      );


    const priceMin =
      source.querySelector(
        '[data-rw-era-price-min]'
      );


    const priceMax =
      source.querySelector(
        '[data-rw-era-price-max]'
      );


    return {

      sortBy:
        sortSelect
          ? sortSelect.value || ''
          : '',

      priceMin:
        priceMin
          ? priceMin.value.trim()
          : '',

      priceMax:
        priceMax
          ? priceMax.value.trim()
          : ''

    };

  }


  /* ========================================================
     GET APPLIED FILTERS
     
     This reads only filters that have already been applied.
     ======================================================== */

  function getAppliedFilters(wrapper = null) {

    const source =
      wrapper ||
      content.querySelector(
        '#rw-era-products'
      );


    if (!source) {

      return getDefaultFilters();

    }


    return {

      sortBy:
        source.dataset.rwEraSort || '',

      priceMin:
        source.dataset.rwEraPriceMin || '',

      priceMax:
        source.dataset.rwEraPriceMax || ''

    };

  }


  /* ========================================================
     BUILD FILTER PARAMETERS
     ======================================================== */

  function buildFilterParams(filters = {}) {

    const params =
      new URLSearchParams();


    if (filters.sortBy) {

      params.set(
        'sort_by',
        filters.sortBy
      );

    }


    if (filters.priceMin) {

      params.set(
        'filter.v.price.gte',
        filters.priceMin
      );

    }


    if (filters.priceMax) {

      params.set(
        'filter.v.price.lte',
        filters.priceMax
      );

    }


    return params;

  }


  /* ========================================================
     FETCH PRODUCT SECTION
     ======================================================== */

  async function fetchProductSection(
    handle,
    page = 1,
    filters = {}
  ) {

    if (!handle) {

      throw new Error(
        'Collection handle is missing.'
      );

    }


    const url =
      `${shopifyRoot}collections/${encodeURIComponent(handle)}`;


    const params =
      buildFilterParams(filters);


    if (page > 1) {

      params.set(
        'page',
        String(page)
      );

    }


    params.set(
      'section_id',
      'rw-era-products'
    );


    const requestUrl =
      `${url}?${params.toString()}`;


    const response =
      await fetch(
        requestUrl,
        {
          method: 'GET',

          credentials: 'same-origin',

          headers: {
            'Accept': 'text/html'
          }
        }
      );


    if (!response.ok) {

      throw new Error(
        `HTTP ${response.status}`
      );

    }


    const html =
      await response.text();


    if (!html.trim()) {

      throw new Error(
        'Shopify returned an empty section.'
      );

    }


    return html;

  }


  /* ========================================================
     RESTORE FILTER VALUES
     ======================================================== */

  function restoreFilterValues(
    wrapper,
    filters
  ) {

    if (!wrapper) return;


    wrapper.dataset.rwEraSort =
      filters.sortBy || '';


    wrapper.dataset.rwEraPriceMin =
      filters.priceMin || '';


    wrapper.dataset.rwEraPriceMax =
      filters.priceMax || '';


    const sortSelect =
      wrapper.querySelector(
        '[data-rw-era-sort]'
      );


    const priceMin =
      wrapper.querySelector(
        '[data-rw-era-price-min]'
      );


    const priceMax =
      wrapper.querySelector(
        '[data-rw-era-price-max]'
      );


    if (sortSelect) {

      sortSelect.value =
        filters.sortBy || '';

    }


    if (priceMin) {

      priceMin.value =
        filters.priceMin || '';

    }


    if (priceMax) {

      priceMax.value =
        filters.priceMax || '';

    }

  }


  /* ========================================================
     SAVE FILTER STATE
     ======================================================== */

  function saveWrapperFilters(
    wrapper,
    filters
  ) {

    if (!wrapper) return;


    wrapper.dataset.rwEraSort =
      filters.sortBy || '';


    wrapper.dataset.rwEraPriceMin =
      filters.priceMin || '';


    wrapper.dataset.rwEraPriceMax =
      filters.priceMax || '';


    saveFilters(
      filters
    );

  }


  /* ========================================================
     CHECK WHETHER PRODUCTS EXIST
     ======================================================== */

  function hasProducts(wrapper) {

    if (!wrapper) return false;


    const productGrid =
      wrapper.querySelector(
        '.rw-era__products'
      );


    if (!productGrid) {

      return false;

    }


    return !!productGrid.querySelector(
      '.rw-era__product-card'
    );

  }


  /* ========================================================
     SHOW NO PRODUCTS MESSAGE
     ======================================================== */

  function showNoProducts(
    wrapper,
    filters
  ) {

    if (!wrapper) return;


    const productGrid =
      wrapper.querySelector(
        '.rw-era__products'
      );


    if (productGrid) {

      productGrid.innerHTML = `
        <div class="rw-era__no-products">
          No products found for this price range.
        </div>
      `;

    } else {

      wrapper.insertAdjacentHTML(
        'beforeend',
        `
          <div class="rw-era__no-products">
            No products found for this price range.
          </div>
        `
      );

    }


    restoreFilterValues(
      wrapper,
      filters
    );


    productView.innerHTML =
      wrapper.outerHTML;


    const insertedWrapper =
      productView.querySelector(
        '#rw-era-products'
      );


    restoreFilterValues(
      insertedWrapper,
      filters
    );


    productView.hidden =
      false;


    collectionView.hidden =
      true;


    setupPriceDropdown();

  }


  /* ========================================================
     INSERT PRODUCT SECTION
     ======================================================== */

  function insertProductWrapper(
    wrapper,
    filters
  ) {

    if (!wrapper) return;


    productView.innerHTML =
      wrapper.outerHTML;


    const insertedWrapper =
      productView.querySelector(
        '#rw-era-products'
      );


    restoreFilterValues(
      insertedWrapper,
      filters
    );


    productView.hidden =
      false;


    collectionView.hidden =
      true;


    setupPriceDropdown();

  }


  /* ========================================================
     LOAD COLLECTION PRODUCTS
     ======================================================== */

  async function loadCollectionProducts(
    handle
  ) {

    /*
     * DEBUG TRACE
     *
     * If typing in a price field still causes this function
     * to run, the browser console will show exactly where
     * the call originated.
     */


    if (!handle) return;


    content.classList.add(
      'is-loading'
    );


    try {

      const savedFilters =
        getSavedFilters();


      const html =
        await fetchProductSection(
          handle,
          1,
          savedFilters
        );


      const temporary =
        document.createElement('div');


      temporary.innerHTML =
        html;


      const products =
        temporary.querySelector(
          '#rw-era-products'
        );


      if (!products) {

        console.error(
          'RW Era returned HTML:',
          html
        );


        throw new Error(
          'rw-era-products container not found.'
        );

      }


      const returnedHandle =
        products.dataset.collectionHandle;


      if (
        returnedHandle &&
        returnedHandle !== handle
      ) {

        throw new Error(
          `Collection mismatch: ${handle} vs ${returnedHandle}`
        );

      }


      if (!hasProducts(products)) {

        showNoProducts(
          products,
          savedFilters
        );

      } else {

        insertProductWrapper(
          products,
          savedFilters
        );

      }


    } catch (error) {

      console.error(
        'RW Era AJAX error:',
        error
      );


      showError(
        'Unable to load this collection. Please try again.'
      );


    } finally {

      content.classList.remove(
        'is-loading'
      );

    }

  }
  /* ========================================================
     COLLECTION CARD CLICK
     
     Collection cards stay inside the
     All Era Collections page.
     
     They use the same AJAX loader as
     the sidebar collection buttons.
     ======================================================== */

  content.addEventListener(
    'click',
    (event) => {

      const link =
        event.target.closest(
          '[data-rw-era-collection-link]'
        );


      if (!link) {
        return;
      }


      /*
       * Prevent the normal collection URL
       * from opening.
       */
      event.preventDefault();


      /*
       * Get the collection handle from
       * the collection card.
       */
      const handle =
        link.dataset.collectionHandle;


      if (!handle) {

        console.error(
          'RW Era: Collection handle is missing from collection card.'
        );

        return;

      }


      /*
       * Find the matching sidebar button.
       *
       * This keeps the sidebar active state
       * synchronized with the collection card.
       */
      const sidebarButton =
        sidebar.querySelector(
          `[data-view="products"][data-collection-handle="${CSS.escape(handle)}"]`
        );


      if (sidebarButton) {

        setActiveSidebarItem(
          sidebarButton
        );

      }


      /*
       * Scroll to the top of the RW Era
       * component instead of the entire page.
       */
      const eraTop =
        rwEra.getBoundingClientRect().top +
        window.scrollY;


      window.scrollTo({
        top: eraTop,
        behavior: 'smooth'
      });


      /*
       * Close mobile sidebar if open.
       */
      if (isMobile()) {

        closeMobileSelector();

      }


      /*
       * Load products inside the existing
       * All Era Collections page.
       */
      loadCollectionProducts(
        handle
      );

    }
  );

  /* ========================================================
     SIDEBAR CLICK
     ======================================================== */

  sidebar.addEventListener(
    'click',
    (event) => {

      const button =
        event.target.closest(
          '.rw-era__sidebar-item'
        );


      if (!button) return;


      setActiveSidebarItem(
        button
      );


      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });


      if (isMobile()) {

        closeMobileSelector();

      }


      const view =
        button.dataset.view;


      if (
        view === 'collections'
      ) {

        showAllCollections();

        return;

      }


      if (
        view === 'products'
      ) {

        const handle =
          button.dataset.collectionHandle;


        loadCollectionProducts(
          handle
        );

      }

    }
  );


/* ========================================================
   SORT CHANGE
   SORT IS IMMEDIATE
   ======================================================== */

content.addEventListener(
  'change',
  async (event) => {

    const sortSelect =
      event.target.closest(
        'select[data-rw-era-sort]'
      );

    /*
     * Ignore everything that is not the Sort select.
     */
    if (!sortSelect) {
      return;
    }

    const wrapper =
      content.querySelector(
        '#rw-era-products'
      );

    if (!wrapper) {
      return;
    }

    const handle =
      wrapper.dataset.collectionHandle;

    if (!handle) {
      return;
    }

    /*
     * IMPORTANT:
     *
     * Sort keeps the CURRENTLY APPLIED price filters.
     *
     * It does NOT read whatever the user may currently
     * be typing into the price inputs.
     */
    const filters =
      getAppliedFilters(wrapper);

    filters.sortBy =
      sortSelect.value || '';

    /*
     * Save the new sort together with the already-applied
     * price filters.
     */
    saveWrapperFilters(
      wrapper,
      filters
    );

    content.classList.add(
      'is-loading'
    );

    try {

      const html =
        await fetchProductSection(
          handle,
          1,
          filters
        );

      const temporary =
        document.createElement('div');

      temporary.innerHTML =
        html;

      const newWrapper =
        temporary.querySelector(
          '#rw-era-products'
        );

      if (!newWrapper) {

        throw new Error(
          'Sorted product container not found.'
        );

      }

      if (!hasProducts(newWrapper)) {

        showNoProducts(
          newWrapper,
          filters
        );

      } else {

        insertProductWrapper(
          newWrapper,
          filters
        );

      }

    } catch (error) {

      console.error(
        'RW Era Sort error:',
        error
      );

      showError(
        'Unable to sort the products. Please try again.'
      );

    } finally {

      content.classList.remove(
        'is-loading'
      );

    }

  }
);


  /* ========================================================
     PRICE APPLY / RESET
     
     THIS IS THE ONLY PLACE WHERE PRICE FILTERS ARE APPLIED.
     ======================================================== */

  content.addEventListener(
    'click',
    async (event) => {

      const applyButton =
        event.target.closest(
          '[data-rw-era-apply]'
        );


      const resetButton =
        event.target.closest(
          '[data-rw-era-reset]'
        );


      if (
        !applyButton &&
        !resetButton
      ) {

        return;

      }


      /*
       * Prevent the click from reaching other theme
       * handlers.
       */

      event.preventDefault();
      event.stopPropagation();


      const wrapper =
        content.querySelector(
          '#rw-era-products'
        );


      if (!wrapper) return;


      const handle =
        wrapper.dataset.collectionHandle;


      if (!handle) return;


      let filters;


      /* ====================================================
         RESET
         ==================================================== */

      if (resetButton) {

        filters =
          getDefaultFilters();

      } else {

        /*
         * ONLY APPLY reads the current input values.
         */

        filters =
          getProductFilters(wrapper);

      }


      /* ====================================================
         VALIDATE PRICE
         ==================================================== */

      if (
        filters.priceMin &&
        filters.priceMax &&
        Number(filters.priceMin) >
        Number(filters.priceMax)
      ) {

        alert(
          'Minimum price cannot be higher than maximum price.'
        );

        return;

      }


      /* ====================================================
         SAVE STATE
         ==================================================== */

      if (resetButton) {

        clearSavedFilters();

      } else {

        saveWrapperFilters(
          wrapper,
          filters
        );

      }


      /* ====================================================
         CLOSE MOBILE PRICE DROPDOWN
         ==================================================== */

      if (isMobile()) {

        closePriceDropdown();

      }


      content.classList.add(
        'is-loading'
      );


      try {

        const html =
          await fetchProductSection(
            handle,
            1,
            filters
          );


        const temporary =
          document.createElement('div');


        temporary.innerHTML =
          html;


        const newWrapper =
          temporary.querySelector(
            '#rw-era-products'
          );


        if (!newWrapper) {

          throw new Error(
            'Filtered product container not found.'
          );

        }


        /* ==================================================
           NO PRODUCTS
           ================================================== */

        if (!hasProducts(newWrapper)) {

          showNoProducts(
            newWrapper,
            filters
          );

        } else {

          insertProductWrapper(
            newWrapper,
            filters
          );

        }


      } catch (error) {

        console.error(
          'RW Era Filter error:',
          error
        );


        showError(
          'Unable to apply the price filter. Please try again.'
        );


      } finally {

        content.classList.remove(
          'is-loading'
        );

      }

    }
  );


/* ========================================================
   PRICE INPUTS

   PRICE INPUTS ARE PASSIVE.

   Typing:
     - NO AJAX
     - NO FILTER REQUEST
     - NO PAGE LOAD

   Blur:
     - NO AJAX

   Apply:
     - applies both values

   Enter:
     - applies both values
   ======================================================== */

content.addEventListener(
  'input',
  (event) => {

    const input =
      event.target.closest(
        '[data-rw-era-price-min], [data-rw-era-price-max]'
      );

    if (!input) {
      return;
    }

    /*
     * IMPORTANT:
     *
     * Do not modify the input value here.
     *
     * The browser handles type="number".
     *
     * Most importantly, this event does NOT
     * perform any AJAX request.
     */

  }
);


/* ========================================================
   PRICE CHANGE

   DO NOTHING.

   This is intentional.

   Changing Min/Max must NOT apply the filter.
   ======================================================== */

content.addEventListener(
  'change',
  (event) => {

    const input =
      event.target.closest(
        '[data-rw-era-price-min], [data-rw-era-price-max]'
      );

    if (!input) {
      return;
    }

    /*
     * Deliberately do nothing.
     */

  }
);

  /* ========================================================
     CLOSE MOBILE SIDEBAR
     ======================================================== */

  document.addEventListener(
    'click',
    (event) => {

      if (!isMobile()) return;


      if (
        !rwEra.contains(
          event.target
        )
      ) {

        closeMobileSelector();

      }

    }
  );


  /* ========================================================
     RESIZE
     ======================================================== */

  window.addEventListener(
    'resize',
    () => {

      if (!isMobile()) {

        closeMobileSelector();

        closePriceDropdown();

      }

    }
  );


  /* ========================================================
     LOAD MORE
     ======================================================== */

  content.addEventListener(
    'click',
    async (event) => {

      const button =
        event.target.closest(
          '#rw-era-load-more'
        );


      if (!button) return;


      const wrapper =
        content.querySelector(
          '#rw-era-products'
        );


      if (!wrapper) return;


      const handle =
        wrapper.dataset.collectionHandle;


      const currentPage =
        Number(
          wrapper.dataset.currentPage || 1
        );


      const totalPages =
        Number(
          wrapper.dataset.totalPages || 1
        );


      const nextPage =
        currentPage + 1;


      if (
        !handle ||
        nextPage > totalPages
      ) {

        return;

      }


      /*
       * Load More uses ONLY already-applied filters.
       */

      const filters =
        getAppliedFilters(wrapper);


      saveWrapperFilters(
        wrapper,
        filters
      );


      button.disabled =
        true;


      button.textContent =
        'Loading...';


      try {

        const html =
          await fetchProductSection(
            handle,
            nextPage,
            filters
          );


        const temporary =
          document.createElement('div');


        temporary.innerHTML =
          html;


        const newWrapper =
          temporary.querySelector(
            '#rw-era-products'
          );


        if (!newWrapper) {

          throw new Error(
            'New product container not found.'
          );

        }


        const currentGrid =
          wrapper.querySelector(
            '.rw-era__products'
          );


        const newGrid =
          newWrapper.querySelector(
            '.rw-era__products'
          );


        if (
          !currentGrid ||
          !newGrid
        ) {

          throw new Error(
            'Product grid not found.'
          );

        }


        /*
         * Append products.
         */

        currentGrid.insertAdjacentHTML(
          'beforeend',
          newGrid.innerHTML
        );


        /*
         * Update page.
         */

        wrapper.dataset.currentPage =
          String(nextPage);


        /*
         * Preserve APPLIED filter state.
         */

        wrapper.dataset.rwEraSort =
          filters.sortBy || '';


        wrapper.dataset.rwEraPriceMin =
          filters.priceMin || '';


        wrapper.dataset.rwEraPriceMax =
          filters.priceMax || '';


        /*
         * Remove Load More when finished.
         */

        if (
          nextPage >= totalPages
        ) {

          const loadMore =
            button.closest(
              '.rw-era__load-more-wrapper'
            );


          if (loadMore) {

            loadMore.remove();

          }

        } else {

          button.disabled =
            false;


          button.textContent =
            'Load More';

        }


      } catch (error) {

        console.error(
          'RW Era Load More error:',
          error
        );


        button.disabled =
          false;


        button.textContent =
          'Load More';

      }

    }
  );


  /* ========================================================
     INITIAL RESTORE
     ======================================================== */

  const initialWrapper =
    content.querySelector(
      '#rw-era-products'
    );


  if (initialWrapper) {

    const savedFilters =
      getSavedFilters();


    if (
      savedFilters.sortBy ||
      savedFilters.priceMin ||
      savedFilters.priceMax
    ) {

      restoreFilterValues(
        initialWrapper,
        savedFilters
      );

    }

  }

});